import { render, staticRenderFns } from "./StandingAccountList.vue?vue&type=template&id=6edb04b0&scoped=true"
import script from "./StandingAccountList.vue?vue&type=script&lang=js"
export * from "./StandingAccountList.vue?vue&type=script&lang=js"
import style0 from "./StandingAccountList.vue?vue&type=style&index=0&id=6edb04b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb04b0",
  null
  
)

export default component.exports